var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.$style['link-wrapper'],on:{"click":function($event){return _vm.$emit('click')}}},[_c('Icon',{class:_vm.$style.icon,attrs:{"name":"link-arrow","active":""}}),_c('div',{class:_vm.$style.label},[_vm._t("default")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }